// extracted by mini-css-extract-plugin
export default {"MainContainer":"BoardsPage_MainContainer__DGy2a"};